import api from "./api";

const classSubjectService = {
  // ==================== CLASS-SUBJECT ASSIGNMENT ====================
  
  // Assign a subject to a class
  assignSubjectToClass: (data) => 
    api.post("/class-subjects", data),

  // Get all class-subject assignments with filters
  getClassSubjects: (params) => 
    api.get("/class-subjects", { params }),

  // Get specific assignment details
  getClassSubjectById: (id) => 
    api.get(`/class-subjects/${id}`),

  // Update class-subject assignment
  updateClassSubject: (id, data) => 
    api.patch(`/class-subjects/${id}`, data),

  // Delete class-subject assignment
  deleteClassSubject: (id) => 
    api.delete(`/class-subjects/${id}`),

  // Get all subjects assigned to a specific class
  // Backend route: GET /api/class-subjects/classes/:classId/subjects
  getSubjectsByClass: (classId, params = {}) =>
    api.get(`/class-subjects/classes/${classId}/subjects`, { params }),

  // Get all classes where a specific subject is taught
  // Backend route: GET /api/class-subjects/subjects/:subjectId/classes
  getClassesBySubject: (subjectId) => 
    api.get(`/class-subjects/subjects/${subjectId}/classes`),
};

export default classSubjectService;
